import React from "react";

export default function UploadIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="27.676" height="24.76" viewBox="0 0 27.676 24.76">
    <path id="upload" d="M8,27.257v1.6a4.818,4.818,0,0,0,4.814,4.814H28.862a4.818,4.818,0,0,0,4.814-4.814v-1.6m-6.419-9.508L20.838,11.33m0,0-6.419,6.419m6.419-6.419V27.257" transform="translate(-7 -9.915)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
  </svg>;
}